import React from "react";

export default function Hero() {
  return (
    <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white pt-32 pb-32 px-6 text-center">
      {/* Badge */}
      <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium tracking-wide mb-8">
        Transforming Self-Insured Healthcare Delivery
      </div>

      {/* Headline */}
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 max-w-4xl mx-auto">
        A Smarter, Tokenized Future for Employer Benefits
      </h1>

      {/* Description */}
      <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-12 max-w-3xl mx-auto">
        BenefitChain is a blockchain and AI platform purpose-built for self-insured employers. 
        It automates funding and utilization of core health, voluntary, and point solution benefits — 
        delivering compliance, efficiency, and real-time insights across PPO networks and HRIS platforms.
      </p>

      {/* Trust Badges */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-6 max-w-2xl mx-auto">
        <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
          HIPAA & ERISA Compliant
        </div>
        <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
          BUCA Network Compatible
        </div>
        <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg text-sm font-medium">
          Integrated with ADP, Workday, UKG
        </div>
      </div>
    </section>
  );
} 